import {atom} from 'jotai';
import {atomWithStorage} from 'jotai/utils';

export const showingModals = atom([]);

export const showDeleted = atom(false);

export const isCollapsed = atom(false);

export const pageSizeRecoil = atomWithStorage('pageSizeRecoil', 10);

export const selectedTabRecoil = atomWithStorage('selectedTabRecoil','support');

export const acknowledgedIds = atomWithStorage('acknowledgedIds', []);

